document.addEventListener('DOMContentLoaded', () => {
  var progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;
  var pathLength = progressPath.getTotalLength();

  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';

  var lastProgress = null;
  var rafId = null;
  var isUpdating = false;

  function getScrollY() {
    return window.scrollY || window.pageYOffset;
  }

  function updateProgress() {
    if (isUpdating) return;
    isUpdating = true;
    
    requestAnimationFrame(() => {
      var scroll = getScrollY();
      var height = document.documentElement.scrollHeight - window.innerHeight;
      if (height <= 0) height = 1;
      var progress = pathLength - (scroll * pathLength) / height;
      
      // Only update if progress actually changed
      if (lastProgress !== progress) {
        progressPath.style.strokeDashoffset = progress;
        lastProgress = progress;
      }
      
      isUpdating = false;
    });
  }

  // Use throttled scroll listener instead of continuous RAF loop
  var handleScroll = theme.utils?.rafThrottle ? theme.utils.rafThrottle(updateProgress) : updateProgress;
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', theme.utils?.rafThrottle ? theme.utils.rafThrottle(updateProgress) : updateProgress, { passive: true });
  
  // Initial update
  updateProgress();
});